import { render, staticRenderFns } from "./ImsDashboard.vue?vue&type=template&id=09a4b180&"
import script from "./ImsDashboard.vue?vue&type=script&lang=js&"
export * from "./ImsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports